<!----
    Author: hjlee
    Description:
        리스트에서 사용할 상세 컴포넌트. 상세보기/입력/수정을 처리한다.
---->
<template>
  <div>
    <div v-if="title" class="subsection-title">
      {{ title }}
    </div>
    <input autocomplete="false" style="display:none" type="text" name="faketextremembered">
    <input autocomplete="false" style="display:none" type="password" name="fakepasswordremembered">
    <div class="rows">
      <div v-for="(column, index) in columns" :key="index">
        <div v-if="!column.inputControl || (column.inputControl.type !== 'none' && isVisibleData(visibleData, column.inputControl.visibleBy, column.inputControl.visibleType))">
          <div v-if="column.sectionTitle" class="section-title">
            {{ $t(column.sectionTitle.text) }}
          </div>
          <div :class="cssClasses(action === 'detail' ? column.detail : column.inputControl)">
            <div class="form-group">
              <div class="controls">
                <input style="display:none" type="text" name="faketextremembered">
                <input style="display:none" type="password" name="fakepasswordremembered">
                <div v-if="column.inputControl && column.inputControl.type === 'section'" class="section-area">
                  <item-detail
                    :ref="action + 'Form.Section-' + column.key"
                    :title="column.label"
                    :module="module"
                    :infos="infos"
                    :name="column.key"
                    :columns="column.columns"
                    :action="action"
                    :visible-data="visibleData"
                    :item="column.targetType.toSnakeCase()"
                    :row="(getContents(row, column.key) && getContents(row, column.key)[0]) ? getContents(row, column.key)[0] : {}"
                    :master-selected-row="masterSelectedRow"
                    @forceUpdate="emitForceUpdate()"
                  />
                </div>
                <div v-else-if="column.inputControl && column.inputControl.type === 'section_list'" class="section-area">
                  <div class="subsection-title">
                    {{ column.label }}
                  </div>
                  <div v-if="!getContents(row, column.key) || getContents(row, column.key).length === 0" class="section-no-data-area">
                    {{ $t('common.text.no_data') }}
                  </div>
                  <div v-else>
                    <div
                      v-for="(sectionRow, sectionRowIndex) in getContents(row, column.key)"
                      :key="sectionRowIndex"
                      class="section-row"
                    >
                      <item-detail
                        :ref="action + 'Form.SectionList-' + column.key + '-' + sectionRowIndex"
                        :module="module"
                        :infos="infos"
                        :name="column.key"
                        :columns="column.columns"
                        :action="action"
                        :visible-data="visibleData"
                        :item="column.targetType.toSnakeCase()"
                        :row="sectionRow"
                        :master-selected-row="masterSelectedRow"
                        @forceUpdate="emitForceUpdate()"
                      />
                      <div v-if="action === 'insert' || action === 'update'" class="section-row-controls-area">
                        <button class="btn btn-danger" @click="deleteRow(getContents(row, column.key), sectionRowIndex)">
                          {{ $t('common.button.delete') }}
                        </button>
                      </div>
                    </div>
                  </div>
                  <div v-if="action === 'insert' || action === 'update'" class="section-controls-area">
                    <button class="btn btn-primary" @click="addRow(getContents(row, column.key), row, column.key)">
                      {{ $t('common.text.add') }}
                    </button>
                  </div>
                </div>
                <div v-else-if="action === 'detail'">
                  <display-control
                    :ref="action + 'Form.' + column.key"
                    :name="column.key"
                    :text-infos="column.common?column.common.textInfos:undefined"
                    :separator-text-infos="column.common?column.common.separatorTextInfos:undefined"
                    :is-html="column.isHtml"
                    :file-info="column.file"
                    :options="getSelectOptions(column)"
                    :value-key="getValueKey(column)"
                    :static-locale="column.inputControl ? column.inputControl.staticLocale : undefined"
                    :static-currency="column.inputControl ? column.inputControl.staticCurrency : undefined"
                    :type="column.inputControl && column.inputControl.type ? column.inputControl.type : undefined"
                    :type-code-field-name="column.inputControl && column.inputControl.typeCodeFieldName"
                    :title="column.label"
                    :visible-data="visibleData"
                    :contents="getContents(row, column.key)"
                    :master-selected-row="masterSelectedRow"
                  />
                </div>
                <div v-else-if="column.inputControl">
                  <input-control
                    :ref="action + 'Form.' + column.key"
                    v-model="row[column.key]"
                    :id-postfix="'-' + index"
                    :node-depth="nodeDepth"
                    :name="column.key.toSnakeCase()"
                    :text-infos="column.common?column.common.textInfos:undefined"
                    :file-info="column.file"
                    :options="getSelectOptions(column)"
                    :title="column.label"
                    :static-locale="column.inputControl.staticLocale"
                    :static-currency="column.inputControl.staticCurrency"
                    :min="column.inputControl.min"
                    :max="column.inputControl.max"
                    :table-name="item"
                    :type="column.inputControl.type"
                    :use-middle-name="column.inputControl.useMiddleName"
                    :async-search-url="column.inputControl.asyncSearchUrl"
                    :type-code-field-name="column.inputControl.typeCodeFieldName"
                    :placeholder="column.inputControl.placeholderTextCode?$t(column.inputControl.placeholderTextCode):undefined"
                    :orderable="column.inputControl.orderable"
                    :multiple="column.inputControl.multiple"
                    :rules="hasAuthority('create_' + item)?getValidationRulesObject(column, module, item, row):{}"
                    :readonly="column[action] && column[action].readonly"
                    :required="column.inputControl.required"
                    :visible-data="visibleData"
                    :notifications="getNotifications(column.inputControl, true)"
                    :prefix="getPrefix(column.inputControl, row)"
                    :postfix="getPostfix(column.inputControl, row)"
                    :master-selected-row="masterSelectedRow"
                    :with-fields="getWithFields(column.inputControl)"
                    @find-zip="findZip(column.key, column.inputControl, $event)"
                    @forceUpdate="emitForceUpdate"
                  />
                  <input-control
                    v-if="column.inputControl.type === 'password'"
                    :ref="action + 'Form.' + column.key + 'Confirm'"
                    v-model="row[column.key + 'Confirm']"
                    :id-postfix="'-confirm-' + index"
                    name="user_pwd_confirm"
                    :text-infos="column.common?column.common.textInfos:undefined"
                    :node-depth="nodeDepth"
                    :type="column.inputControl.type"
                    :use-middle-name="column.inputControl.useMiddleName"
                    :type-code-field-name="column.inputControl.typeCodeFieldName"
                    :placeholder="column.inputControl.placeholderTextCode?$t(column.inputControl.placeholderTextCode):undefined"
                    :orderable="column.inputControl.orderable"
                    :multiple="column.inputControl.multiple"
                    :rules="'password_confirm:' + row[column.key]"
                    :required="column.inputControl.required"
                    :master-selected-row="masterSelectedRow"
                    @forceUpdate="emitForceUpdate"
                  />
                </div>
              </div>
            </div>
            <memo-control
              v-if="column.memoOptions"
              :key="index"
              :memo-options="column.memoOptions"
              :table-name="item"
              :table-key="row[column.memoOptions.key]"
              :column-name="column.key"
              :collapse="column.memoOptions.collapse"
            />
          </div>
          <div v-if="column.clear" class="clear" />
        </div>
      </div>
      <div class="clear" />
      <additional-field-info-control
        v-if="infos && infos.additionalFieldInfo && row.additionalFieldInfos"
        :ref="action + 'Form.additionalFieldInfoControl'"
        v-model="row.additionalFieldInfos"
        class="cols-xs-12 cols-sm-12 cols-md-12 cols-lg-12 cols-xl-12"
        :info="infos.additionalFieldInfo"
        :readonly="action === 'detail'"
        :module="module"
        :item="item"
        @forceUpdate="emitForceUpdate"
      />
      <additional-field-control
        v-if="infos && infos.additionalFieldInfoData"
        :ref="action + 'Form.additionalFieldControl'"
        v-model="row"
        :display="action === 'detail'"
        :table-name="item"
        :info-data="infos.additionalFieldInfoData"
        class="cols-xs-12 cols-sm-12 cols-md-12 cols-lg-12 cols-xl-12"
        @forceUpdate="emitForceUpdate"
      />
      <additional-field-sample-control
        v-if="infos && infos.additionalFieldInfoSampleData"
        v-model="row"
        :display="action === 'detail'"
        :table-name="item"
        :info-data="infos.additionalFieldInfoSampleData"
        class="cols-xs-12 cols-sm-12 cols-md-12 cols-lg-12 cols-xl-12"
        :readonly="true"
      />
      <div class="clear" />
    </div>
    <div id="addr-search-layer">
      <div class="zip-close-button clickable" @click="closeZip()">
        <i class="fa fa-close" />
      </div>
      <div id="addr-search-container" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    infos: {
      type: Object,
      default: undefined
    },
    columns: {
      type: Array,
      required: true
    },
    action: {
      type: String,
      required: true
    },
    name: {
      type: String,
      default: ''
    },
    module: {
      type: String,
      required: true
    },
    title: {
      type: String,
      default: undefined
    },
    item: {
      type: String,
      required: true
    },
    visibleData: {
      type: Object,
      default: undefined
    },
    nodeDepth: {
      type: Number,
      default: undefined
    },
    row: {
      type: [Array, Object],
      required: true
    },
    masterSelectedRow: {
      type: [Array, Object],
      default: undefined
    }
  },
  data() {
    return {
      isMounted: false
    }
  },
  mounted() {
    this.isMounted = true
  },
  methods: {
    addRow(list, row, key) {
      if (row && key && !row[key]) {
        list = row[key] = []
      }
      list.push({})
      this.$forceUpdate()
    },
    deleteRow(list, index) {
      list.splice(index, 1)
      this.$forceUpdate()
    },
    closeZip() {
      $(this.$el)
        .find('#addr-search-layer')
        .fadeOut()
    },
    findZip(key, inputControl) {
      $(this.$el)
        .find('#addr-search-layer')
        .fadeIn()
      window.openDaumPostcode(
        this.row,
        key,
        inputControl.relatedInputName,
        'addr-search-container',
        $(this.$el).find('#addr-search-layer'),
        this,
        inputControl.nextInputName
          ? $(this.$el).find(
              '[original-name=' + inputControl.nextInputName.toSnakeCase() + ']'
            )
          : undefined
      )
    }
  }
}
</script>

<style scoped>
.section-title {
  font-size: 1.3rem;
  font-weight: bold;
  padding: 45px 15px 5px 15px;
  margin-bottom: 15px;
  border-bottom: 1px solid #cccccc;
  clear: both;
}
.rows div:first-child .section-title {
  padding-top: 0;
}
.section-controls-area {
  text-align: right;
}
.section-row-controls-area {
  text-align: right;
  margin-top: 10px;
}
.section-no-data-area {
  text-align: center;
  padding: 50px 0;
}
.section-row {
  border: 1px solid #cccccc;
  padding: 10px;
  margin-bottom: 10px;
}
.section-area {
  border: 1px solid #cccccc;
  padding: 0 20px 20px 20px;
  margin-bottom: 10px;
}
.subsection-title {
  font-size: 1.1rem;
  font-weight: bold;
  padding: 25px 0px 5px 0px;
  margin-bottom: 15px;
  border-bottom: 1px solid #cccccc;
  clear: both;
}
#addr-search-layer {
  display: none;
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 9999;
  background: white;
  padding-top: calc(1rem + 15px);
}
#addr-search-container {
  width: 100%;
  height: 100%;
}
.zip-close-button {
  color: black;
  font-weight: bold;
  right: 5px;
  top: 5px;
  padding: 5px;
  font-size: 1rem;
  position: fixed;
}
</style>
